import { Controller } from "@hotwired/stimulus"

// Opens an anchor's href in a sized popup window (e.g. social share buttons).
// Usage:
//   <a href="https://example.com/share" target="my-popup"
//      data-controller="popup"
//      data-popup-width-value="600"
//      data-popup-height-value="600"
//      data-action="click->popup#open">Share</a>
export default class extends Controller {
  static values = {
    width: { type: Number, default: 600 },
    height: { type: Number, default: 600 }
  }

  open(event) {
    event.preventDefault()
    const link = event.currentTarget
    const features = `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${this.widthValue},height=${this.heightValue}`
    window.open(link.href, link.target, features)
  }
}
